import isValidUSPhoneNumber from './isValidUSPhoneNumber';

const validatePhone = (phone: string) => {
  if (!isValidUSPhoneNumber(phone)) return 'Phone Invalid';
  return true;
};

export default validatePhone;
